declare interface Window {
    newContractModule: any;
    parseJsonDate(date: string): Date;
    textSessionExpired: string;
    IndexUrl: string;
    SetThemedMinDates(): void;
    funnelStep(step: any): void;
    setCountries(url: string, defaultCountry: string, cultureForCountries: string): any;
    checkMovingDate(minDate: number): void;
    isAuthenticated: boolean;
    salesChannel: string;
}

window.setCountries = function (url, defaultCountry: string, cultureForCountries: string) {
    $.post(url, { culture: cultureForCountries }).done(function (data) {
        if (data != null && data.length > 0) {
            var options = "";
            $.each(data, function (key, val) {
                options += "<option value='" + val + "'>" + val + "</option>"
            });
            $(".countrySelect").html(options);
            $(".countrySelect").val(defaultCountry).change();
            return data;
        }
    });
}

window.checkMovingDate = function (minDate: number) {
    var today = new Date();
    if (window.newContractModule.contract.ContractReason === 2 || window.newContractModule.contract.ContractReason === 13) {
        var moveInStart = window.newContractModule.contractSettings.MoveInStartDate.split(".");
    }
    else {
        var moveInStart = window.newContractModule.contractSettings.NewContractStartDate.split(".");
    }

    var movingMinDate = Date.today().addDays(minDate);

    var movDay = movingMinDate.getDay();

    var hours = new Date().getHours();

    //SQOOMI-621 R.Kosarev fixed adding days in case of the weekend (implemenation of SQOOMI-217)
    if ((movDay == 1 || movDay == 2 || movDay == 3 || movDay == 4) && (hours > 15)) {
        // Oomi Support went home for the day, move contract to the next day
        movingMinDate = movingMinDate.addDays(1);
    }
    else if (movDay == 5 && hours > 15) {
        //it's Friday night, Oomi Support went home for the weekend
        // original day MOVED IN CODE to Friday, move it to Monday
        movingMinDate = movingMinDate.addDays(3);
    }
    else if (movDay == 6) {
        //it's Saturday
        // original day MOVED IN CODE to Saturday, move it to Monday
        movingMinDate = movingMinDate.addDays(2);
    }
    else if (movDay == 0) {
        // movDay is Sunday
        // original day MOVED IN CODE to Sunday, move it to Monday
        movingMinDate = movingMinDate.addDays(1);
    }

    // SQOOMI-890 R.Kosarev:
    // for Enerim maintenance break, uncommen this code
    // and set the correct maintenance dates
    //var currentDateTime = new Date();
    //var enerimMaintenanceStart = new Date("2024-01-17, 16:00");
    //var enerimMaintenanceEnd = new Date("2024-01-23");
    //if (currentDateTime.getTime() > enerimMaintenanceStart.getTime()) // it's on baby
    //{
    //    movingMinDate = new Date(Math.max(movingMinDate.getTime(), enerimMaintenanceEnd.getTime()));
    //}

    $("#start-date").datepicker("option", "minDate", movingMinDate);

    if (window.newContractModule.contract.StartDate !== null && window.parseJsonDate(window.newContractModule.contract.StartDate) < movingMinDate) {
        try {
            var server = $.connection.newContractHub.server;
            server.setContractValue("StartDate", movingMinDate.toString("dd.MM.yyyy")).done(function (sd) {
                console.log(sd);
            });
        }
        catch (error) {
            window.newContractModule.blockUI(window.textSessionExpired != null ? window.textSessionExpired : "Istunto on vanhentunut");
            window.newContractModule.timeout(3000).then(function () {
                window.location.href = window.IndexUrl;
            });
        }
    }
}


window.SetThemedMinDates = function () {
    var server = $.connection.newContractHub.server;
    var today = new Date();
    $("#sop-pvm-info, #sop-pvm-info-supplier-change").hide();

    if (window.newContractModule.contract.ContractReason === 1 || window.newContractModule.contract.ContractReason === 12) {
        $("#sop-pvm-info-supplier-change").show();
    }
    else if (window.newContractModule.contract.ContractReason === 2 || window.newContractModule.contract.ContractReason === 4 || window.newContractModule.contract.ContractReason === 13) {
        $("#sop-pvm-info").show();
    }

    // R. Kosarev SQOOMI-413:
    $("#move-out-date").datepicker("option", "maxDate", 180);

    if (window.newContractModule.contract.ContractReason === 1 || window.newContractModule.contract.ContractReason === 3 ||
        window.newContractModule.contract.ContractReason === 12 || window.newContractModule.contract.ContractReason === 11 ||
        window.newContractModule.contract.ContractReason === 99) {
        $("#start-date").datepicker("destroy");
        $("#start-date").datepicker({
            dateFormat: 'dd.mm.yy',
            beforeShowDay: function (date) {
                return [true, ""];
            }
        });

        var maxDate = 185;
        //SQOOMI-1004 2.9.2024 R.Kosarev: Uusmyynnin sopimuslomake B2B, myyjänvaihdon alkamisen max nosto 90 vrk -> 180 vrk
        //ContractReason = 12: myyjänvaihto / supplier change
        if (window.newContractModule.contract.ContractReason === 12)
        {
            if (window.salesChannel === 'Uusmyynti' && window.newContractModule.contract.CustomerType == 2) {
                maxDate = 180;
            }
            else {
                maxDate = 90;
            }
        }

        $("#start-date").datepicker("option", "maxDate", maxDate);

        var supplierChangeMinDate = Date.today().addDays(window.newContractModule.contractSettings.SupplierChangeMinDates);

        if (window.newContractModule.contract.ContractReason === 3 || window.newContractModule.contract.ContractReason === 11 // PRODUCTCHANGE
            || window.newContractModule.contract.ContractReason === 1 || window.newContractModule.contract.ContractReason === 12) { // SUPPLIERCHANGE
            var hour = today.getHours();
            var day = today.getDay();

            var minDays = window.newContractModule.contractSettings.SupplierChangeMinDates;
            // Contract cannot be done for next day after 23:00
            if (hour > 22) {
                minDays++;
            }

            supplierChangeMinDate = Date.today().addDays(minDays);
        }

        var effectiveMinDate = new Date(); // just date variable initialization

        // SQOOMI-642 SQOOMI-949 R.Kosarev:
        var allowProductChangeForNextDay = window.newContractModule.contract.ContractReason === 11 && (window.isAuthenticated || window.salesChannel === 'Sopimusuusinta')  
        if (allowProductChangeForNextDay) {
            // user is authenticated and we are changing product/contract (not supplier)
            $("#start-date").datepicker("option", "minDate", Date.today().addDays(1));
            effectiveMinDate = Date.today().addDays(1);
        }
        else { // all other reasons except product/contract change for an authenticated customer or on Sopimusuusinta seller web form
            $("#start-date").datepicker("option", "minDate", supplierChangeMinDate);
            effectiveMinDate = supplierChangeMinDate;
        }

        // SQOOMI-890 R.Kosarev:
        // for Enerim maintenance break, uncommen this code
        // and set the correct maintenance dates
        //var currentDateTime = new Date();
        //var enerimMaintenanceStart = new Date("2024-01-17, 16:00");
        //var enerimMaintenanceEnd = new Date("2024-01-23");
        //if (currentDateTime.getTime() > enerimMaintenanceStart.getTime()) // it's on baby
        //{
        //    if (window.newContractModule.contract.ContractReason === 11 || window.newContractModule.contract.ContractReason === 13) {
        //        // move-in or a new contract/product change
        //        // set date either to the 23rd of January or the minDate calculated earlier, whichever is later
        //        // compare the two dates as numbers and then set the later date to the effectiveMinDate
        //        // Joni: "ettei minimipäivät vähene"
        //        effectiveMinDate = new Date(Math.max(effectiveMinDate.getTime(), enerimMaintenanceEnd.getTime()));
        //        $("#start-date").datepicker("option", "minDate", effectiveMinDate);
        //    }
        //    else if (window.newContractModule.contract.ContractReason === 12) // supplier change
        //    {
        //        // if we change supplier, the specs are to add 18 days (SQOOMI-890)
        //        effectiveMinDate = currentDateTime.addDays(18);
        //        $("#start-date").datepicker("option", "minDate", effectiveMinDate);
        //    }
        //}

        if (window.newContractModule.contract.StartDate !== null && window.parseJsonDate(window.newContractModule.contract.StartDate) < effectiveMinDate) {
            try {
                //trasanen 30.1.2017 server is undefined if not set here
                server.setContractValue("StartDate", effectiveMinDate.toString("dd.MM.yyyy")).done(function (sd) {
                    console.log(sd);
                });
            }
            catch (error) {
                window.newContractModule.blockUI(window.textSessionExpired != null ? window.textSessionExpired : "Istunto on vanhentunut");
                window.newContractModule.timeout(3000).then(function () {
                    window.location.href = window.IndexUrl;
                });
            }
        }

    }
    // Others
    else {
        $("#start-date").datepicker("destroy");
        var holidays = [];
        server.getHolidays(1).done(function (res) {
            holidays = res.Data;
        });

        $("#start-date").datepicker({
            dateFormat: 'dd.mm.yy',
            beforeShowDay: function (date) {
                var dateString = jQuery.datepicker.formatDate('d.m.yy', date);
                var res = holidays.indexOf(dateString) == -1;
                return [res, ""];
            }
        });
        
        if ($.isFunction(window.checkMovingDate)) {
            if (window.newContractModule.contractSettings != undefined && window.newContractModule.contractSettings != null)
                if (window.newContractModule.contractSettings.MovingMinDates != undefined && window.newContractModule.contractSettings.MovingMinDates != null)
                    window.checkMovingDate(window.newContractModule.contractSettings.MovingMinDates);
        } else {
            $("#start-date").datepicker("option", "minDate", window.newContractModule.contractSettings.MovingMinDates);
        }
        $("#start-date").datepicker("option", "maxDate", 90);
        if (window.newContractModule.contractSettings != undefined && window.newContractModule.contractSettings != null)
            if (window.newContractModule.contractSettings.ClosingMinDates != undefined && window.newContractModule.contractSettings.ClosingMinDates != null) {
                $("#move-out-date").datepicker("option", "minDate", window.newContractModule.contractSettings.ClosingMinDates);
                $("#old-contract-end-date").datepicker("option", "minDate", window.newContractModule.contractSettings.ClosingMinDates);
            }
    }
}

// to support unsupported thing
interface Window {
    dataLayer: any[];
}

window.funnelStep = function(step) {
    var nametemp = $(".pricelist:checked")?.attr("data-product-name");
    var name = nametemp?.replace(/ /g, '');
    var id = nametemp?.replace(/ /g, '');
    var category = $("input[name='tarification']:checked").next().children().html();

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'checkout',
        'ecommerce': {
            'checkout': {
                'actionField': { 'step': step }, //Funnel step number  
                'products': [{  // Product being ordered
                    'name': name,   // Readable name of the product, required
                    'id': id, // Name of the product without spaces, dynamic, required
                    'category': category, // Type of measuring (mittaustapa). Either Yleissähkö, Aikasähkö or Kausisähkö. Optional.
                    'price': '1' // Constant of 1
                }]
            }
        }
    });
}